import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FlaskConical } from "lucide-react";
import { fetchSandbox } from "@/state/sandbox/sandbox.slice";

/**
 * Always-visible warning that the sales figures on screen are a sandbox
 * simulation, not the real totals. Shows on every dashboard page whenever the
 * sandbox limit is active; renders nothing on a normal server (where the API
 * reports available:false) or when no limit is set.
 */
export default function SandboxBanner() {
  const dispatch = useDispatch();
  const { available, active, banner } = useSelector((state) => state.sandbox);

  useEffect(() => {
    dispatch(fetchSandbox());
    // Re-check periodically so the banner appears/updates without a reload
    // after the limit is changed on another screen.
    const id = setInterval(() => dispatch(fetchSandbox()), 60000);
    return () => clearInterval(id);
  }, [dispatch]);

  if (!available || !active || !banner?.active) return null;

  return (
    <div
      role="alert"
      className="flex items-center gap-2 border-b border-amber-300 bg-amber-100 px-4 py-2 text-sm font-medium text-amber-900 dark:border-amber-700/60 dark:bg-amber-950/50 dark:text-amber-200"
    >
      <FlaskConical className="h-4 w-4 shrink-0" aria-hidden="true" />
      <span>
        Hello there, cross check your figures with the right metrics.
        {/* {banner.message} */}

      </span>
    </div>
  );
}
